
import React from "react";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface HeroSectionProps {
  handleBackToHome: () => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  handleBackToHome
}) => {
  return <>
      <section className="relative h-[400px] flex items-center justify-center px-6">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: "url('/assets/icons/dreamstime_xxl_47633494.jpg')",
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }} />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 text-center -mt-48">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Guided Hunting Experience</h1>
          <p className="text-xl text-white max-w-2xl mx-auto">Join the Shoshone-Paiute Tribes for the Hunting Adventure of a Lifetime</p>
        </div>
        
        {/* Move the button to bottom-left with absolute positioning */}
        <div className="absolute bottom-4 left-4 md:bottom-8 md:left-8 z-20">
          <Button variant="outline" onClick={handleBackToHome} className="text-tribal-secondary border-tribal-neutral hover:bg-tribal-light/20">
            <Compass className="mr-2 h-4 w-4" /> Back to Home
          </Button>
        </div>
      </section>
    </>;
};
